<template>
    <app-layout title="Nieuwe offertes Dewaele">
        <template #header>
            <page-title title="Nieuwe offertes Dewaele" />
        </template>

        <template #pageContent>
            <TableSearch tableId="overview-dewaele-potential-offers" :values="potentialOffers" class="w-1/4" placeholder="Zoeken"/>

            <Table id="overview-dewaele-potential-offers" :values="potentialOffers" class="mt-4 w-4/6">
                <thead>
                    <tr>
                        <Th id="details.json_data.reference">Dossiernr.</Th>
                        <Th id="details.json_data.invoice_information.name">Klant</Th>
                        <Th id="details.json_data.invoice_information.street">Inspectie adres</Th>
                        <Th id="created_at">Aangevraagd op</Th>
                        <Th :sort="false"></Th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(potentialOffer, key) in state.sortedValues['overview-dewaele-potential-offers']" :key="key">
                        <Td>{{ potentialOffer['details']['json_data']['reference'] }}</Td>
                        <Td>{{ potentialOffer['details']['json_data']['invoice_information']['name'] }}</Td>
                        <Td>
                            {{ potentialOffer['details']['json_data']['inspection_location_address']['street'] }} {{ potentialOffer['details']['json_data']['inspection_location_address']['number'] }} {{ potentialOffer['details']['json_data']['inspection_location_address']['box'] }}<br>
                            {{ potentialOffer['details']['json_data']['inspection_location_address']['zip_code'] }} {{ potentialOffer['details']['json_data']['inspection_location_address']['city'] }}
                        </Td>
                        <Td>
                            <template v-if="potentialOffer.created_at">
                                {{ moment(potentialOffer.created_at).format('DD/MM/YYYY') }}
                            </template>
                        </Td>
                        <Td>
                            <Button
                                buttonClass="show"
                                size="small"
                                @click="loadPotentialOffer(potentialOffer['details']['json_data']['reference'])"
                            />
                        </Td>
                    </tr>
                </tbody>
            </Table>
            <Modal
                id="modal-potential-offer"
                visible="hidden"
                @modalClosed="modalClosed"
                ref="modalOffer"
            >
                <div class="pt-4" v-if="loadingOffer">
                    <i class="fas fa-spinner fa-pulse mr-1"></i> Even geduld, bezig met ophalen van offerte data.
                </div>
                <DewaelePotentialOffer
                    :offer="offer"
                    :reference="reference"
                    :surfaces="surfaces"
                    :surfaceId="surfaceId"
                    :attachments="attachments"
                    :attachmentsPath="attachmentsPath"
                    @closeModal="closeModal"
                    v-if="offerLoaded"
                />
            </Modal>
        </template>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import PageTitle from '@/Components/PageTitle.vue'
import Table from '@/Components/Table.vue'
import Th from '@/Components/Th.vue'
import Td from '@/Components/Td.vue'
import Button from '@/Components/Button.vue'
import TableSearch from '@/Components/TableSearch.vue'
import Modal from '@/Components/Modal.vue'

import DewaelePotentialOffer from "@/Components/Requests/DewaelePotentialOffer.vue";

import {onMounted, ref, watch} from 'vue'
import store from '@/store'
import moment from "moment"
import { Inertia } from "@inertiajs/inertia"
import { Link, usePage  } from '@inertiajs/inertia-vue3'


export default {
    components: {
        DewaelePotentialOffer,
        AppLayout,
        PageTitle,
        Button,
        Table,
        Td,
        Th,
        TableSearch,
        Modal,
        Link,
    },
    props: [
        'potentialOffers',
        'offer',
        'reference',
        'surfaces',
        'surfaceId',
        'attachments',
        'attachmentsPath',
    ],
    setup (props, { attrs }){
        let offerLoaded = ref(false)
        let modalOffer = ref(null)
        let loadingOffer = ref(false)

        function loadPotentialOffer(reference) {
            loadingOffer.value = true
            modalOffer.value.show = true

            Inertia.reload(//We need to send the offer reference as a query parameter
                {
                    data: { reference: reference },
                    only: ['offer', 'reference', 'surfaceId', 'attachments', 'attachmentsPath'],
                    onSuccess: () => {
                        loadingOffer.value = false
                        offerLoaded.value = true
                    },
                }
            )
        }

        function modalClosed()
        {
            loadingOffer.value = false
        }

        function closeModal() {
            modalOffer.value.show = false
            offerLoaded.value = false
        }

        return {
            state: store.state,
            ...store,
            modalOffer,
            loadingOffer,
            loadPotentialOffer,
            modalClosed,
            closeModal,
            offerLoaded,
        }
    },
    created: function () {
        this.moment = moment;
    },
}

</script>
